/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { isEmpty, sample } from "lodash";
import { Home } from "@material-ui/icons";
import { Button, Form } from "react-bootstrap";
import ClipAnimation from "./ClipAnimation";
import Correlation from "./Correlation";
import SelectDropdown from "./SelectDropdown";
import MaterialTextureInteraction from "./MaterialTextureInteraction";
import Accordion from "./Accordion";
import Opacity from "./Opacity";
import Slots from "./Slots";
import AddColorSlot from "./AddColorSlot";
import { uploadFileToS3 } from "../../modules/SKUClient";
import { removeEmptySelections } from "./utils/configHelper";
import {
  ENGINE_COMPONENT_TYPES,
  ICON_LABELS,
  ACTION_MAP,
  ACCORDION_LIST,
} from "../../constants";

const ActionComponent = ({
  type: configType,
  action,
  currentConfig,
  onAddColorSlot,
  ...rest
}) => {
  const {
    OPACITY_COMPONENT,
    MATERIALS_COMPONENT,
    ADD_SLOTS,
    CLIP_ANIMATION_COMPONENT,
    CORRELATION_COMPONENT,
  } = ENGINE_COMPONENT_TYPES;

  const configData =
    configType === "onLoad"
      ? rest.templateConfig.getConfigByPlatform(currentConfig[configType], [])
      : currentConfig[configType];
  const componentData = configData?.find(
    ({ type }) => type === ACTION_MAP[action]
  )?.config;

  switch (action) {
    case OPACITY_COMPONENT: {
      return <Opacity {...rest} currentConfig={componentData} />;
    }
    case MATERIALS_COMPONENT: {
      return (
        <MaterialTextureInteraction
          {...rest}
          configType={configType}
          currentConfig={componentData}
        />
      );
    }
    case ADD_SLOTS:
      return (
        <Slots
          {...rest}
          currentConfig={currentConfig}
          onCreateSlot={onAddColorSlot}
          showCreateSlot={rest.heirarchy.includes("colorChangeIcon")}
        />
      );
    case CLIP_ANIMATION_COMPONENT: {
      return <ClipAnimation {...rest} currentConfig={componentData} />;
    }
    default:
      return null;
  }
};

const AccordionContent = ({
  actions,
  type,
  currentConfig,
  updateConfig,
  interactiveConfig,
  onAddColorSlot,
  templateConfig,
}) => {
  return (
    <div className="accordionContainer">
      {actions?.map((action) => {
        return (
          <ActionComponent
            key={action}
            action={action}
            type={type}
            {...interactiveConfig}
            updateConfig={updateConfig(ACTION_MAP[action])}
            currentConfig={currentConfig}
            getOptions={interactiveConfig.templateConfig.getOptions}
            childComponent={interactiveConfig.templateConfig?.children ?? null}
            onAddColorSlot={onAddColorSlot}
            templateConfig={templateConfig}
          />
        );
      })}
    </div>
  );
};

const ThreeDInteractivityTab = ({ interactiveConfig, templateConfig }) => {
  const [buttonConfig, setButtonConfig] = useState(
    interactiveConfig?.attachedConfig
  );
  const [showAddColorModal, setAddColorModal] = useState(false);
  const [forceUpdater, setForceUpdater] = useState(0);
  const panelActions = interactiveConfig?.templateConfig?.actions;
  const activeButtons = (buttonConfig?.menu ?? []).filter(
    (slot) => slot.enabled !== false
  );
  useEffect(() => {
    setButtonConfig(interactiveConfig?.attachedConfig);
  }, [interactiveConfig]);

  const onUploadColorIcon = async (file) => {
    const { skuId, clientId } = interactiveConfig.getContextData();
    const category = `assets`;
    const fileUrl = await uploadFileToS3(file, skuId, clientId, category);
    return fileUrl;
  };

  const updateCorrelationConfig = (config, configType) => {
    const currentConfig = { ...buttonConfig };
    currentConfig[configType] = config;
    setButtonConfig({ ...currentConfig });
    interactiveConfig.addButtonConfig({ ...currentConfig });
    setForceUpdater(forceUpdater + 1);
  };

  const updateConfig = (selectionType) => {
    return (configType) => {
      return (config) => {
        const configData = {
          type: configType,
          config,
        };
        let existingConfigIndex = -1;
        const currentConfig = { ...buttonConfig };
        if (selectionType === "onLoad") {
          currentConfig[selectionType] = templateConfig.updateOnLoadConfig(
            currentConfig[selectionType],
            configData,
            configType,
            false
          );
        } else if (selectionType === "onSlot") {
          setButtonConfig(config);
        } else if (
          !["onLoad", "onSlot"].includes(selectionType) &&
          currentConfig[selectionType]?.length > 0
        ) {
          existingConfigIndex = currentConfig[selectionType]?.findIndex(
            (e) => e.type === configType
          );
          if (existingConfigIndex > -1) {
            currentConfig[selectionType][existingConfigIndex] = configData;
          } else if (!isEmpty(config)) {
            currentConfig[selectionType].push(configData);
          }
        } else if (!isEmpty(config)) {
          currentConfig[selectionType] = [];
          currentConfig[selectionType].push(configData);
        }
        console.log("currentConfig", currentConfig);
        const updatedConfig = { ...currentConfig };
        // if (!["onLoad", "onSlot"].includes(selectionType))
        //   updatedConfig = removeEmptySelections(currentConfig);
        setButtonConfig({ ...updatedConfig });
        console.log("finalConfig", updatedConfig);
        interactiveConfig.addButtonConfig({ ...updatedConfig });
        setForceUpdater(forceUpdater + 1);
      };
    };
  };
  console.log(
    "ThreeDInteractivityTabs",
    buttonConfig,
    interactiveConfig,
    panelActions,
    interactiveConfig?.templateConfig,
    buttonConfig?.menu
  );
  if (!buttonConfig && !interactiveConfig)
    return (
      <div className="threeDInteractivityContainer loadingContainer">
        <div>No Config Found</div>
      </div>
    );

  return (
    <div className="threeDInteractivityContainer">
      {interactiveConfig?.heirarchy?.length > 0 && (
        <div className="breadcrumbContainer">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Button
                onClick={() => interactiveConfig.setInteractivePage(...[])}
                type="secondary"
              >
                <Home fontSize="small" />
              </Button>
            </Breadcrumb.Item>
            {interactiveConfig?.heirarchy?.map((item, index) => (
              <Breadcrumb.Item
                key={item}
                active={
                  interactiveConfig?.heirarchy[
                    interactiveConfig?.heirarchy - 1
                  ] === item
                }
              >
                <Button
                  type="secondary"
                  onClick={() =>
                    interactiveConfig.setInteractivePage(
                      ...interactiveConfig?.heirarchy.slice(0, index + 1)
                    )
                  }
                >
                  {ICON_LABELS[item] ?? item}
                </Button>
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
      )}
      <div className="tabContent">
        {interactiveConfig?.templateConfig?.actions && (
          <Accordion
            className="selection-accordion"
            actions={interactiveConfig?.templateConfig?.actions || null}
            panelList={Object.keys(panelActions).map((actionKey) => {
              if (panelActions[actionKey].length === 0) return null;
              if (actionKey === "onCorrelate") return null;
              return {
                header: ACCORDION_LIST[actionKey],
                headerClass: `${actionKey}-accordion-header`,
                component: (
                  <AccordionContent
                    type={actionKey}
                    currentConfig={buttonConfig}
                    updateConfig={updateConfig(actionKey)}
                    interactiveConfig={interactiveConfig}
                    actions={panelActions[actionKey]}
                    onAddColorSlot={() => setAddColorModal(true)}
                    templateConfig={templateConfig}
                  />
                ),
              };
            })}
          />
        )}
        {interactiveConfig?.templateConfig?.correlation && (
          <Correlation
            currentConfig={buttonConfig?.correlation ?? null}
            updateCorrelationConfig={(data) =>
              updateCorrelationConfig(data, "correlation")
            }
            correlation={interactiveConfig?.templateConfig?.correlation}
          />
        )}
        {templateConfig?.enableDefaultButtonConfig &&
          activeButtons.length > 0 &&
          interactiveConfig?.heirarchy.length === 0 && (
            <div className="default-button-container">
              <Form.Label>Set Default Selected Button</Form.Label>
              <SelectDropdown
                placeholder="Select a button"
                menuList={[
                  ...activeButtons.map((m) => ({
                    label: ICON_LABELS[m.name],
                    value: m.name,
                  })),
                  { label: "Remove Default", value: "" },
                ]}
                onMenuSelect={(value) => {
                  templateConfig?.updateDefaultButtonConfig(value);
                  setForceUpdater(forceUpdater + 1);
                }}
                value={templateConfig?.getDefaultButtonConfig()}
              />
            </div>
          )}
      </div>
      {showAddColorModal && (
        <AddColorSlot
          showModal={showAddColorModal}
          onCloseColorSlot={() => setAddColorModal(false)}
          onUploadColorIcon={onUploadColorIcon}
          onSaveSlotData={(data) => {
            const updatedConfig = buttonConfig;
            updatedConfig.menu = [...updatedConfig.menu, data];
            setButtonConfig(updatedConfig);
            interactiveConfig.addButton(data);
            interactiveConfig.addButtonConfig({ ...updatedConfig });
            setForceUpdater(forceUpdater + 1);
          }}
        />
      )}
    </div>
  );
};

export default ThreeDInteractivityTab;
